angular.module('unica_report.report_services')

.factory('ReportListService', function ($http, getBaseApiURL) {

	var reportListService = {};

	reportListService.invitationList = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/invitation-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.report;
			}

		});

	};

	reportListService.invitationsByType = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/invitations-by-type/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.report;
			}

		});
	};

	reportListService.invitationsByStatus = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/invitations-by-status/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.report;
			}

		});
	};

	reportListService.checkin = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/checkin/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.report;
			}

		});
	};

	reportListService.checkinByStage = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/checkin-by-stage/' + eventId,
			data: { }
		}).then(function(result) {

			console.log(result);

			if ( result ) {
				return result.data.report;
			}

		});
	};

	reportListService.checkinByTime = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/report/checkin-by-time/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.report;
			}

		});
	};


	reportListService.invitationsByListAndCategory = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/invitations-by-list-and-category/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	reportListService.invitationsByZoneManagerAndArea = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/invitations-by-zone-manager-and-area/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	reportListService.campaignsStatus = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/campaigns-status/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	reportListService.declinedInvitations = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/declined-invitations/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return reportListService;
});